import React from 'react'
import './Project.css'
import portfolio from './portfolio.png'
import colorPicker from './colorPicker.png'
import SSY from './SSY.png'
import Tabletap from './Tabletap.png'

export default function Projects() {
       
  return (
    <div id='project'>
        <div className='text-4xl text-center '>PROJECTS</div>
    <div className='flex justify-center items-center flex-col'>
      <div className='text-2xl mt-5'>Table Tap</div>
        <div className='flex flex-col bg-gray-300 max-w-7xl m-12  lg:flex-row p-4 rounded-lg items-center justify-center'>

            <div className='flex justify-center mx-5 sm:mx-10 w-2/4 '>
                <img className=''src={Tabletap} alt="please reload" />
            </div>
            <div className=' text-lg lg:text-xl mx-10 sm:mx-10 mt-2'>
            <p><strong> A QR based Food Ordering  web application</strong><br />
                    registers the restaurant with functionalities of managing orders,menu and team members;
                    <br/>Techonolgies used: NextJs,Tailwind CSS and Firebase</p> 
                      
                    <div className='flex space-x-4 mt-4'>
                    <div className="block button "><a href="https://table-ordering-f9s2.vercel.app/">Demo</a></div>
                    <div className="block button "><a href="https://github.com/Utkarsh13-ray/Table-Ordering">Code</a></div>
                    </div>
            </div>

        </div> 
      <div className='text-2xl'>Stadium Ticket Booking</div>
        <div className='flex flex-col bg-gray-300 max-w-7xl m-12  lg:flex-row-reverse p-4 rounded-lg items-center justify-center'>

            <div className='flex justify-center mx-5 sm:mx-10 '>
                <img className=''src={SSY} alt="please reload"/>
            </div>
            <div className=' text-lg lg:text-xl mx-10 sm:mx-10 mt-2'>
            <p><strong>Stadium Ticket Booking System</strong>
               A portal for booking of tickets for the matches for Inter College Sports Tournament
                    <br/>Techonolgies used: MERN Stack</p>
                    <div className='flex space-x-4 mt-4'>
                    <div className="block button "><a href="https://stadium-ticket-booking.netlify.app/">Demo </a></div>
                    <div className="block button "><a href="https://github.com/Utkarsh13-ray/Stadium-ticket-booking">Code</a></div>
                    </div>
            </div>

        </div> 
      
      <div className='text-2xl mt-5'>Portfolio</div>
        <div className='flex flex-col bg-gray-300 max-w-7xl m-12  lg:flex-row p-4 rounded-lg items-center justify-center'>

            <div className='flex justify-center mx-5 sm:mx-10 w-2/4 '>
                <img className=''src={portfolio} alt="please reload" />
            </div>
            <div className=' text-lg lg:text-xl mx-10 sm:mx-10 mt-2'>
            <p><strong> My Self Portfolio is fully responsible web application</strong><br />
                    consists of details about my education,projects,contact etc.
                    <br/>Techonolgies used: Reactjs and Tailwind CSS</p> 
                      
                    <div className='flex space-x-4 mt-4'>
                    <div className="block button "><a href="/">Demo</a></div>
                    <div className="block button "><a href="https://github.com/Utkarsh13-ray/myportfolio">Code</a></div>
                    </div>
            </div>

        </div> 
      <div className='text-2xl'>Color GO</div>
        <div className='flex flex-col bg-gray-300 max-w-7xl m-12  lg:flex-row-reverse p-4 rounded-lg items-center justify-center'>

            <div className='flex justify-center mx-5 sm:mx-10 '>
                <img className=''src={colorPicker} alt="please reload"/>
            </div>
            <div className=' text-lg lg:text-xl mx-10 sm:mx-10 mt-2'>
            <p><strong>Color-GO  (Color Picker Eyedropper)</strong>
               You can pick color with help of eyedropper and copy the rgb,hsl and hex codes of any color.
                    <br/>Techonolgies used: HTML,CSS and JavaSript</p>
                    <div className='flex space-x-4 mt-4'>
                    <div className="block button "><a href="https://color-go.netlify.app">Demo </a></div>
                    <div className="block button "><a href="https://github.com/Utkarsh13-ray/Color-Go">Code</a></div>
                    </div>
            </div>

        </div> 
      
    </div>
          
    </div>
  )
}
